/** Paths that show one unit's command centre, chosen from the context the viewer was in. */
const COMMAND_CENTRE_PATH = /^\/(?:$|teams\/|value-streams\/|divisions\/|units\/)/

/**
 * Where to go after the viewer switches context, or null to stay put.
 *
 * A command centre belongs to the context it was opened from: a team member's `/`
 * redirects to `/teams/:id`, so choosing the value stream from there changed nothing on
 * screen. Those pages go back to `/`, which opens the new context's own, on the same tab
 * where that tab exists. Anything else (Strategy, Directory, Check-in) re-renders under
 * the new context where it stands.
 */
export function pathAfterContextSwitch(pathname: string, search: string): string | null {
  if (!COMMAND_CENTRE_PATH.test(pathname)) return null
  // Only the tab carries over: the rest of the query (an objective, a sub-tab) names
  // things in the context being left.
  const tab = new URLSearchParams(search).get('tab')
  const target = tab ? `/?tab=${encodeURIComponent(tab)}` : '/'
  return target === `${pathname}${search}` ? null : target
}
